// extracted by mini-css-extract-plugin
module.exports = {"refundLink":"_3de-3j"};